<template>
  <div class="card card-plain">
    <div class="pb-0 card-header text-start">
      <h4 class="font-weight-bolder" style="color: #0385F3;">Masuk</h4>
      <p class="mb-0">Selamat datang di sistem KPI Monitoring Bank Sumsel Babel</p>
    </div>
    <div class="card-body">
      <form @submit.prevent="login()">
        <div class="mb-3">
          <FormGroup>
            <input-form type="text" v-model="form.username" name="username" placeholder="NIP" />
          </FormGroup>
        </div>
        <div class="mb-3" style="text-align: right;">
          <FormGroup style="margin: 0;">
            <InputForm type="password" v-model="form.password" name="password" placeholder="Password" :showable="true" />
          </FormGroup>
          <argon-button :to="{ name: 'Forgot Password' }" btnstyle="link">Lupa kata sandi?</argon-button>
        </div>

        <div class="text-center">
          <argon-button class="mt-4" variant="gradient" color="#0385F3" textcolor="#fff" fullWidth size="lg">MASUK</argon-button>
        </div>
      </form>
    </div>
    <div class="px-1 pt-0 text-center card-footer px-lg-2">
      <p class="mx-auto mb-4 text-sm">
        Belum punya akun?
        <argon-button :to="{ name: 'Signup' }" btnstyle="link" class="fw-bold">Daftar</argon-button>
      </p>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import AuthApi from "../../repository/api/AuthApi";
import { reloadAxios } from "../../repository/api/Axios";
import FormGroup from '../../components/FormGroup.vue';
import InputForm from '../../components/InputForm.vue';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    ArgonButton,
    FormGroup,
    InputForm,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    }
  },
  async mounted() {
    if (localStorage.getItem("token")) {
      await AuthApi.check_token({
        token: localStorage.getItem("token").toString(),
      }).then(() => {
        this.$router.push({ name: "Dashboard" });
      }).catch(() => {
        this.logout();
        localStorage.removeItem("token");
        this.$store.state.token = '';
      });
    }
  },
  methods: {
    async login() {
      this.$store.state.loading = true;

      await AuthApi.login(this.form)
        .then(async (response) => {
          localStorage.setItem("token", response.data.token);
          this.$store.state.token = response.data.token;
          reloadAxios();
          this.$router.push({ name: "Dashboard" })

        }).catch((error) => {
          this.$store.state.loading = false;
          switch (error?.response?.status ?? null) {
            case 401:
              this.$swal({
                icon: "error",
                title: 'NIP dan password tidak cocok',
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: error?.response?.data.message ?? "",
              });
              break;
          }
        });

      this.$store.state.loading = false;
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
